export function disableEmptyDates(date: any, allDates: any) {
  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()
  const dateFormatted = `${day}-${month}-${year}`
  return !allDates.includes(dateFormatted)
}
